module.exports = __webpack_public_path__ + "img/picture.29427818.png";